import { createModelStore } from '@/shared/stores/create-model-store'
import { model1InitialModel } from './initial-state'
import { model1DimensionHandlers } from './dimensions'

export const useModel1Store = createModelStore({
  initialModel: model1InitialModel,
  dimensionHandlers: model1DimensionHandlers,
})
